<template>
	<div style="overflow-y: scroll;height: 100%;">
		<div style="display: flex;margin-left: 10px;">
			<a-select show-search allowClear placeholder="PC首页背景" class="margin_self" v-model="uploadData.pathNew" style="width: 200px">
				<a-select-option :value="item.dictValue" v-for="(item, index) in newPath" :key="index">
					{{ item.dictLabel }}
				</a-select-option>
			</a-select>
			<uploadImgBack :data="uploadData" v-if="isRouterAlive" @replacement="pathOk" style="margin:0 10px" />
		</div>
		<div class="box">
			<div class="item" v-for="(item, index) in info" :key="index">
				<img :src="item.url" style="width: 100%;height: 100%;" @click="show_img(index, info)"/>
				<a-icon class="close_icon" @click="close_detail(index)" type="close" />
			</div>
		</div>
		<preview ref="preview" />
	</div>
</template>

<script>
	import {
		list_static,
		file_del_java_static
	} from '@/api/activiti'
	import { getDictDataList } from '@/api/system'
	import preview from '@/components/module/prview2'
	import uploadImgBack from '@/components/module/uploadImgBack.vue'
	export default {
		components:{
			uploadImgBack,
			preview,
		},
		data(){
			return{
				newPath:[],
				info:[],
				isRouterAlive:true,
				uploadData: {
					pathNew:undefined,
					types: ['application/pdf','image/png','image/jpeg','image/svg+xml'],
				},
			}
		},
		created(){
			this.list()
			getDictDataList({
				pageNum:1,
				pageSize:999,
				dictType:'static_path'
			}).then(res=>{
				this.newPath=res.rows
			})
		},
		methods:{
			close_detail(idx){
				var _this = this
				this.$confirm({
					title: '是否确认删除?',
					onOk() {
						file_del_java_static({
							types:_this.info[idx].types,
							path:_this.info[idx].path
						}).then(res=>{
							if(res.code==200){
								_this.$message.success(res.message)
								_this.list()
							}
						})
					},
					onCancel() {
						_this.$message.error('你点击了取消')
					},
					class: 'test',
				})
				
			},
			show_img(idx, imgs) {
				var row = {
					index: idx,
					imgs: imgs,
				}
				this.$refs.preview.show(row)
			},
			list(){
				list_static().then(res=>{
					this.info=res.data
				})
			},
			pathOk(data){
				this.list()
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
			},
		}
	}
</script>

<style>
	.box .item{
		border-radius: 5px;
		float: left;
		width: 288px;
		height: 162px;
		margin: 10px;
		border: 1px solid lightgray;
	}
	.box .item .close_icon {
		font-size: 20px;
		color: red;
		cursor: pointer;
		position: relative;
		left: calc(100% - 10px);
		top: calc(-100% - 10px);
	}
</style>
